import { render, staticRenderFns } from "./Despachos_Aceite_Romana.vue?vue&type=template&id=57316713&scoped=true&"
import script from "./Despachos_Aceite_Romana.vue?vue&type=script&lang=js&"
export * from "./Despachos_Aceite_Romana.vue?vue&type=script&lang=js&"
import style0 from "./Despachos_Aceite_Romana.vue?vue&type=style&index=0&id=57316713&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57316713",
  null
  
)

export default component.exports